// Settings Service
// Handles all settings-related API calls

import authService from './Auth.services.js';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://the-live-cure-be.vercel.app/api';

class SettingsService {
  // General Settings
  async getGeneralSettings() {
    try {
      const token = authService.getToken();
      
      if (!token) {
        throw new Error('No authentication token');
      }

      const response = await fetch(`${API_BASE_URL}/settings/general`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch general settings');
      }

      const data = await response.json();
      return data.settings;
    } catch (error) {
      console.error('Get general settings error:', error);
      throw error;
    }
  }

  async updateGeneralSettings(settingsData) {
    try {
      const token = authService.getToken();
      
      if (!token) {
        throw new Error('No authentication token');
      }

      const response = await fetch(`${API_BASE_URL}/settings/general`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(settingsData),
      });

      if (!response.ok) {
        throw new Error('Failed to update general settings');
      }

      const data = await response.json();
      return data.settings;
    } catch (error) {
      console.error('Update general settings error:', error);
      throw error;
    }
  }

  // Notification Settings
  async getNotificationSettings() {
    try {
      const token = authService.getToken();
      
      if (!token) {
        throw new Error('No authentication token');
      }

      const response = await fetch(`${API_BASE_URL}/settings/notifications`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch notification settings');
      }

      const data = await response.json();
      return data.settings;
    } catch (error) {
      console.error('Get notification settings error:', error);
      throw error;
    }
  }

  async updateNotificationSettings(settingsData) {
    try {
      const token = authService.getToken();
      
      if (!token) {
        throw new Error('No authentication token');
      }

      const response = await fetch(`${API_BASE_URL}/settings/notifications`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(settingsData),
      });

      if (!response.ok) {
        throw new Error('Failed to update notification settings');
      }

      const data = await response.json();
      return data.settings;
    } catch (error) {
      console.error('Update notification settings error:', error);
      throw error;
    }
  }

  // Security Settings
  async getSecuritySettings() {
    try {
      const token = authService.getToken();
      
      if (!token) {
        throw new Error('No authentication token');
      }

      const response = await fetch(`${API_BASE_URL}/settings/security`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch security settings');
      }

      const data = await response.json();
      return data.settings;
    } catch (error) {
      console.error('Get security settings error:', error);
      throw error;
    }
  }

  async updateSecuritySettings(settingsData) {
    try {
      const token = authService.getToken();
      
      if (!token) {
        throw new Error('No authentication token');
      }

      const response = await fetch(`${API_BASE_URL}/settings/security`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(settingsData),
      });

      if (!response.ok) {
        throw new Error('Failed to update security settings');
      }

      const data = await response.json();
      return data.settings;
    } catch (error) {
      console.error('Update security settings error:', error);
      throw error;
    }
  }

  // Appearance Settings
  async getAppearanceSettings() {
    try {
      const token = authService.getToken();
      
      if (!token) {
        throw new Error('No authentication token');
      }

      const response = await fetch(`${API_BASE_URL}/settings/appearance`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch appearance settings');
      }

      const data = await response.json();
      return data.settings;
    } catch (error) {
      console.error('Get appearance settings error:', error);
      throw error;
    }
  }

  async updateAppearanceSettings(settingsData) {
    try {
      const token = authService.getToken();
      
      if (!token) {
        throw new Error('No authentication token');
      }

      const response = await fetch(`${API_BASE_URL}/settings/appearance`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(settingsData),
      });

      if (!response.ok) {
        throw new Error('Failed to update appearance settings');
      }

      const data = await response.json();
      return data.settings;
    } catch (error) {
      console.error('Update appearance settings error:', error);
      throw error;
    }
  }

  // Get All Settings
  async getAllSettings() {
    try {
      const token = authService.getToken();
      
      if (!token) {
        throw new Error('No authentication token');
      }

      const response = await fetch(`${API_BASE_URL}/settings/all`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch all settings');
      }

      const data = await response.json();
      return data.settings;
    } catch (error) {
      console.error('Get all settings error:', error);
      throw error;
    }
  }
}

// Create and export a singleton instance
const settingsService = new SettingsService();
export default settingsService;
